import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import UpcommingAssessment from "./components/UpcomingAssessment";
import MockAssessment from './components/MockAssessment';
import { useTranslation } from 'react-i18next';

const ViewAssessement = () => {      

  const {t} = useTranslation()
  
  useEffect(() => {
      /*window.onbeforeunload = function(event) {
            event.preventDefault();
            event.returnValue = '';
          }*/
      sessionStorage.setItem('active-page-view', 'normal-exam')
    }, []);

  return (
    <div className='bg-whit'>       
        <section className='jumbotron bg-white p-4 flex flex-wrap items-center justify-between gap-3'>
            <div>
              <Link to={'/candidate/assessments/view-assessments'} className='text-lg'>
                {t('exam')}
              </Link>
              <span className='mx-2'>/</span>
              <Link to={'/candidate/assessments/view-assessments'} className='text-lg text-customGreen'>
                {t('view-exams')}
              </Link>
            </div>
            <Link
              to={'/candidate/assessments/compatibility-test'}
              className='bg-primary rounded-full text-white py-4 px-8 text-xl'
            >
              {t('compatibility-test')}
            </Link>
        </section>                  
          <div className='pb-3'>
             <UpcommingAssessment  />
          </div>               
    </div>
  )
}

export default ViewAssessement
